{
  "documentTypeRequired": "Dokumentasjonstype må velges først",
  "downloadFailed": "Kunne ikke laste ned {{fileName}}",
  "requiredField": "Dette feltet er obligatorisk",
  "description": {
    "label": "Beskrivelse",
    "placeholder": "Legg til en beskrivelse"
  },
  "confirm": {
    "cancelFileUpload": {
      "title": "Er du sikker på at du vil avbryte?",
      "description": "Endringer du har gjort, inkludert opplastede filer og beskrivelser, vil ikke bli lagret.",
      "actionLabel": "Avbryt uten å lagre",
      "cancelLabel": "Fortsett redigering"
    },
    "deleteFile": {
      "title": "Er du sikker på at du vil slette filen?",
      "description": "Denne handlingen kan ikke reverseres. Filen vil bli slettet permanent.",
      "actionLabel": "Slett"
    }
  }
}
